import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import parse from "html-react-parser";

// Prime React Components
import { FilterMatchMode } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { MultiSelect } from 'primereact/multiselect';
import { Button } from 'primereact/button';
import { Accordion, AccordionTab } from 'primereact/accordion';


// Needed URLS
import { GET_AUDIT } from '../constants/URLS';

// Needed common templates
import { timeStampTemplate } from '../constants/commonTemplates'


const Audit = (props) => {

	// PAGE REFS
	const toast = useRef(null);
    const dt = useRef(null);

	// STATE VARIABLES
	const [audit, setAudit] = useState(null);
	const [globalFilter, setGlobalFilter] = useState(null);
	const [users, setUsers] = useState([]);
	const [auditTypes, setAuditTypes] = useState([]);
	const [filters1, setFilters1] = useState({});

	// USE EFFECTS HOOKS
	useEffect(() => {
        fncGetAudit()
		initFilters1();
    }, []); 

	// ACTION / XHR FUNCTIONS
	const fncGetAudit = async (data) => {
		let _audit = await axios({method: 'get', url: GET_AUDIT})
		setAudit(_audit.data.results)
		let _users = _audit.data.results.reduce((acc,cur) => {
			if (cur.userName.trim() !== '') acc[cur.userName] = cur.userName
			return acc
		},{})

		setUsers(Object.keys(_users).map(cur => {
			return {
				label: cur, 
				value: cur
			}
		}))

		let _auditTypes = _audit.data.results.reduce((acc,cur) => {
			if (cur.auditType.trim() !== '') acc[cur.auditType] = cur.auditType
			return acc
		},{})

		setAuditTypes(Object.keys(_auditTypes).map(cur => {
			return {
				label: cur, 
				value: cur
			}
		}).sort((a,b) => (a.label > b.label?1:-1)))
	};

	

	// OTHER FUNCTIONS
	const userFilterTemplate = (options) => {
        return <MultiSelect value={options.value} options={users} onChange={(e) => options.filterApplyCallback(e.value)} placeholder="Any" className="p-column-filter" />;
    }

	const initFilters1 = () => {
        setFilters1({
           	'userName': { value: null, matchMode: FilterMatchMode.IN },
			'auditType': { value: null, matchMode: FilterMatchMode.IN },
        });
    }

	const clearFilter = () => {
        initFilters1();
    }

	const auditTypeFilterTemplate = (options) => {
		return <MultiSelect filter value={options.value} options={auditTypes} onChange={(e) => options.filterApplyCallback(e.value)} placeholder="Any" className="p-column-filter" />;
    }

	

	// TABLE COLUMN TEMPLATES (table provides rowdata and column info, can draw how needed)
	const tableDetailsTemplate = (rowData) => {
        return (
            <div className="flex">
				{rowData.auditTable} {rowData.auditTableID > 0 && <>({rowData.auditTableID})</>}
			</div>
        );
    }

	const jsonTemplate = (rowData, column) => {
        return (
            <div className="flex json" >
				<Accordion style={{width: '100%'}}>
					<AccordionTab header="View Details">
						<pre>
							<p className="json">
								{parse(JSON.stringify(JSON.parse(rowData[column.field]),null,2))}
							</p>
						</pre>
					</AccordionTab>
				</Accordion>
			</div>
        );
    }


	// OTHER TEMPLATES (JSX)
	const auditHeader = () => {
        return (
            <div className="flex">
                <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined" onClick={clearFilter} />
            </div>
        )
    }

	// DRAW OUT THE HTML
	return (
	   <div className="audit">
	       <div className="card">
		  	 <DataTable ref={dt} value={audit} sortField="auditID" sortOrder={-1} header={auditHeader()}
                dataKey="auditID" paginator rows={10} rowsPerPageOptions={[5, 10, 25]}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} logs"
                responsiveLayout="stack" filters={filters1} 
				>
                    <Column field="auditID" header="Audit ID" sortable style={{ width: '8%',verticalAlign:'top' }}></Column>
					<Column field="timeStamp" body={timeStampTemplate} header="Time Stamp" sortable style={{ width: '15%',verticalAlign:'top' }}></Column>
					<Column field="userName" header="User" style={{ width: '12%',verticalAlign:'top' }} sortable
						filterField="userName" showFilterMenuOptions={false} showAddButton={false} 
						filter filterElement={userFilterTemplate}  
					/>                  
				    <Column field="auditType" header="Audit Type" sortable style={{ width: '15%',verticalAlign:'top' }}
						filterField="auditType" showFilterMenuOptions={false} showAddButton={false} 
						filter filterElement={auditTypeFilterTemplate}   showApplyButton={false} showClearButton={false}
					/>
					<Column field="auditTable" body={tableDetailsTemplate} header="Table Info" style={{ width: '15%',verticalAlign:'top' }}></Column>
					<Column field="auditDetails" body={jsonTemplate} header="Details" style={{ width: '30%',verticalAlign:'top' }}></Column>
                </DataTable>
	       </div>
	   </div>
	);
}

export default Audit;